import React, { useState, useEffect, useMemo } from 'react';
import customHeaders, { getSpace } from '../../../../../common/headers';
import { TitlePage } from '../../../../../components/TitlePage/TitlePage';
import { ButtonBasic, InputDinamycPlaceholder, DropDownSelector } from "@lk-gtcom/ecomlab-components";
import useGeneralStore from '../../../../../store/general';
import { DynamicFormComponent } from '../../../../../components/DynamicFormComponent/DynamicFormComponent';
import { ModalAddElementsDict } from './ModalAddElementsDict/ModalAddElementsDict';
import './CreateBordFields.scss';


interface CreateBordFieldsProps {
    funnelId: number
    crm: boolean
    task: boolean
    ticket: boolean
}

const TYPE_LIST = [
    {
        label: 'Строка',
        value: 'string'
    },
    {
        label: 'Чекбокс',
        value: 'bool'
    },
    {
        label: 'Число',
        value: 'int'
    },
    {
        label: 'Дробное число',
        value: 'float'
    },
    {
        label: 'Список с выбором значений',
        value: 'dict'
    },
    {
        label: 'Проценты',
        value: 'percent'
    },
    {
        label: 'Теги',
        value: 'array'
    },
    {
        label: 'Поле ввода для текста',
        value: 'field'
    },
]

const CreateBordFields = ({
    funnelId,
    crm = false,
    task = false,
    ticket = false
}: CreateBordFieldsProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    // Поля 
    const [selectedType, setSelectedType] = useState(TYPE_LIST[0])
    const [fieldsdName, setFieldsName] = useState('')
    const [fields, setFilds] = useState([])
    const [fieldsArr, setFieldsArr] = useState([])
    const [fieldsList, setFieldsList] = useState([])

    // Модалка
    const [isModalAddElementsDict, setIsModalAddElementsDict] = useState(false)

    // Добавление полей
    const addFields = (fieldsdName) => {
        fetchAddAdditionalFieldsFunnel(fieldsdName)
        setFieldsName('');
    };

    // Получение полей
    const fetchGetAdditionalFields = (
        abortController = new AbortController()
    ) => {
        let url = ` https://portals.ecomru.ru/api/crm/funnels/get_additional_field/${funnelId}`
        if (ticket) {
            url = ` https://portals.ecomru.ru/api/ticket/funnel/get_additional_field/${funnelId}`
        }

        fetch(url, {
            method: 'GET',
            headers,
            signal: abortController.signal,
        })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error('bad events response');
                }
            })
            .then((json) => {
                setFieldsArr(json);
                setFilds(json?.map(({ name, id, type, possible_values, before }) => ({ front_name: name, data_type: type, id: id, possible_values: possible_values, before: before })))
            })
            .catch((err) => {
                console.error(err);
            });
        // .finally(() => {
        //     setLoad(false)
        // })
    };

    // Добавление доп полей к воронке
    const fetchAddAdditionalFieldsFunnel = (name: string) => {
        let url = ` https://portals.ecomru.ru/api/crm/funnels/create_additional_field`
        if (ticket) {
            url = ` https://portals.ecomru.ru/api/ticket/funnel/create_additional_field`
        }

        const body = JSON.stringify({
            funnel_id: funnelId,
            name: name,
            type: selectedType?.value,
            possible_values: listDict,
            before: null
        });

        fetch(url, { method: 'POST', headers, body })
            .then(res => {
                if (!res?.ok) { throw new Error('bad response') }
                return res.json()
            })
            .then(json => {
                setTimeout(() => fetchGetAdditionalFields(), 500)
                setListDict([])
            })
            .catch((err) => console.error(err));
    };

    // Изменение доп полей к воронке
    const fetchChangeAdditionalFieldsFunnel = (name: string, id: number | string, type: string, before: null | number | string = null, possible_values: [] | undefined) => {
        let url = ` https://portals.ecomru.ru/api/crm/funnels/update_additional_field`
        if (ticket) {
            url = ` https://portals.ecomru.ru/api/ticket/funnel/update_additional_field`
        }

        const body = JSON.stringify({
            funnel_id: funnelId,
            possible_values,
            name: name,
            type: type,
            field_id: id,
            before
        });

        fetch(url, { method: 'PATCH', headers, body })
            .then(res => {
                if (!res?.ok) { throw new Error('bad response') }
                return res.json()
            })
            .then(json => {
                setTimeout(() => fetchGetAdditionalFields(), 500)
            })
            .catch((err) => console.error(err));
    };

    // Удаление поля у воронки
    const fetchDeleteAdditionalFieldsProject = (id: number | string) => {
        let url = ` https://portals.ecomru.ru/api/crm/funnels/delete_additional_field/${id}`
        if (ticket) {
            url = ` https://portals.ecomru.ru/api/ticket/funnel/delete_additional_field/${id}`
        }

        fetch(url, { method: 'DELETE', headers })
            .then(res => {
                if (!res?.ok) { throw new Error('bad response') }
                return res.json()
            })
            .then(json => {
                setTimeout(() => fetchGetAdditionalFields(), 500)
            })
            .catch((err) => console.error(err));
    };

    useMemo(() => {
        setFieldsList([
            ...fields.map(({ name, type, id }, ind) => {
                return (
                    <div className="modal-add-project__fields-item">
                        <InputDinamycPlaceholder
                            changeValue={name}
                            onChange={(e) => handleInput(e ? e : name, ind)}
                            //  placeholder={name}
                            size="s"

                        />
                        <ButtonBasic
                            onClick={() => {
                                fetchDeleteAdditionalFieldsProject(id)
                            }}
                            red
                            text="Удалить"
                        />
                    </div>
                );
            }),
        ]);
    }, [fields]);


    useEffect(() => {
        fetchGetAdditionalFields();
    }, []);

    const handleInput = (e, index) => {

        const curr = fields.map(({ name, field_type, id, possible_values }, ind) => {
            if (ind === index) {
                return { name: e, field_type: 'string', id: id, possible_values: possible_values || [] };
            } else {
                return { name: name, field_type: 'string', id: id, possible_values: possible_values || [] };
            }
        });
        setFilds(curr);
    };


    const [listDict, setListDict] = useState([])

    return (
        <>
            {isModalAddElementsDict &&
                <ModalAddElementsDict
                    list={listDict}
                    setList={setListDict}
                    setIsModal={setIsModalAddElementsDict}
                />}


            <div className="create-bord-fields">
                <TitlePage
                    medium
                    title={'Добавление полей'}
                />

                <div className="create-bord-fields__request-list">
                    <div className='create-bord-fields__fields'>
                        <div className="create-bord-fields__fields-row">
                            <InputDinamycPlaceholder
                                changeValue={fieldsdName}
                                onChange={(e) => setFieldsName(e)}
                                placeholder="Введите название поля"
                                size="s"
                            />

                            <DropDownSelector
                                options_prop={TYPE_LIST}
                                state={selectedType}
                                setState={(e) => setSelectedType(e)}
                                placeholder="Тип поля"
                                isClearable={false}
                            />

                            <ButtonBasic
                                minWidth='210px'
                                blue
                                disabled={selectedType?.value !== 'dict'}
                                text='Настроить список'
                                onClick={(e) => {
                                    setIsModalAddElementsDict(true)
                                }}
                            />

                            <ButtonBasic
                                green
                                minWidth='auto'
                                text="Создать"
                                onClick={() => {
                                    if (fieldsdName?.length > 0) {
                                        addFields(fieldsdName);
                                    }
                                }}
                            />
                        </div>


                    </div>

                    <div className="create-bord-fields__fields-group">
                        <TitlePage
                            medium
                            title={'Готовые поля'}
                        />
                        <div className="create-bord-fields__fields-content">
                            <DynamicFormComponent
                                draggable={true}
                                productTemporary={fields}
                                fetchDelete={fetchDeleteAdditionalFieldsProject as any}
                                fetchChange={fetchChangeAdditionalFieldsFunnel as any}
                                isEdit={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { CreateBordFields };